import styled, { css } from 'styled-components';

import { colors } from 'global/colors';
import { Images } from 'assets/images';

export const PlansContainer = styled.div`
  background-image: url(${Images.paymentBackground});
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: center;
  background-attachment: fixed;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 100vh;
  width: 100%;
`;

export const PlansWrapper = styled.div`
  background-color: rgba(192, 192, 192, 0.7);
  border-radius: 15px;
  padding: 15px;
  max-width: 80%;
  min-width: 400px;
  text-align: ${(props) => (props.alignLeft ? 'left' : 'center')};
`;

export const TabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex-wrap: nowrap;
`;

export const LabelHeading = styled.h5``;

export const TransactionHeading = styled.h4`
  font-weight: 600;
`;

export const EmailLink = styled.a`
  color: ${colors.fsDarkBlue};
  font-weight: bold;

  :hover {
    color: ${colors.fsDarkBlue};
  }
`;

export const PaymentPageLink = styled.a`
  color: ${colors.darkGray2};

  :hover {
    color: ${colors.darkGray2};
  }
`;

export const VATInput = styled.input`
  width: 200px;
  margin: auto;
  margin-top: 10px;
  padding: 6px 8px;
  border: none;
  border-radius: 5px;
  :focus-visible {
    outline: none;
  }
`;

export const VATStatusText = styled.label`
  color: ${colors.darkRed};
`;

export const OptionsContainer = styled.div`
  border-radius: 0px;
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
`;

export const OptionsDisplay = styled.span`
  border-bottom: 3px solid ${colors.fsDarkBlue};
  border-radius: 0px;
  font-weight: bold;
  padding: 0px 10px;
  cursor: pointer;
  color: ${colors.fsDarkBlue};
  text-transform: uppercase;
  font-family: 'Open Sans', sans-serif;
  ${({ activeTab, option }) =>
    activeTab === option
      ? css`
          border-bottom: 3px solid ${colors.white};
          color: ${colors.white};
        `
      : css`
          :hover {
            border-bottom: 3px solid ${colors.fsDarkBlueHoverLight};
            color: ${colors.fsDarkBlueHoverLight};
          }
        `}
`;
